import { FC, memo } from 'react'
import { Link } from 'react-router-dom'
import { useRecentDraftsQuery } from './useRecentDraftsQuery'
import { getUrgencyLevel } from './urgencyHelper'

import { ReactComponent as AlertIcon } from 'images/icons/flag-circle.svg'
import { ReactComponent as CheckIcon } from 'images/icons/check-circle.svg'
import { ReactComponent as LoadingIcon } from 'images/icons/clock.svg'

import styles from './RecentDraftsBox.module.scss'

const RecentDraftsBox: FC = () => {
  const { data, isLoading, isError, error } = useRecentDraftsQuery()

  if (isLoading) {
    return (
      <div className={`${styles.container} ${styles.loading}`}>
        <div className={styles.content}>
          <LoadingIcon className={styles.icon} />
          <span className={styles.text}>Checking for recent console petitions...</span>
        </div>
      </div>
    )
  }

  if (isError) {
    return (
      <div className={`${styles.container} ${styles.error}`}>
        <div className={styles.content}>
          <AlertIcon className={styles.icon} />
          <span className={styles.text}>
            Unable to check recent console petitions
            {error instanceof Error && `: ${error.message}`}
          </span>
        </div>
      </div>
    )
  }

  if (!data || data.total === 0) {
    return (
      <div className={`${styles.container} ${styles.success}`}>
        <div className={styles.content}>
          <CheckIcon className={styles.icon} />
          <span className={styles.text}>No pending console petitions in the last 24 hours</span>
        </div>
      </div>
    )
  }

  const urgencyLevel = getUrgencyLevel(data.total)

  return (
    <div className={`${styles.container} ${styles[urgencyLevel]}`}>
      <div className={styles.content}>
        <AlertIcon className={styles.icon} />
        <div className={styles.textContainer}>
          <span className={styles.text}>
            <strong>{data.total}</strong> pending draft{data.total !== 1 ? 's' : ''} in the last 24 hours
          </span>
          {data.items.length > 0 && (
            <span className={styles.subtitle}>Most recent: {data.items[0].data.title || 'Untitled Draft'}</span>
          )}
        </div>
        <Link to="/backoffice/drafts?status=pending_review" className={styles.link}>
          View All
        </Link>
      </div>
    </div>
  )
}

export default memo(RecentDraftsBox)
